<div id="NetworkTimelineContainer">
  @if (!noData && canReadElasticSearch) {
    <div class="row" id="NetworkArea">
      <div [chart]="chart" id="NetworkChart" style="min-width: 19.375rem; height: 20rem; margin: 0 auto">
        <!-- chart renders here -->
      </div>
    </div>
  }

  @if (noData && !networkLoading) {
    <div class="noData" id="NoNetworkArea">No Data</div>
  }
  @if (!canReadElasticSearch && !networkLoading) {
    <div class="noData" id="NoNetworkArea">No Permissions</div>
  }
  <app-loader [isLoading]="networkLoading"></app-loader>
</div>
